import { ChartOptions, EVPData, StrikeZone } from '../../../schema/types.ts'
import canBePersonalized from './can-be-personalized.ts'

export default function getStrikeZoneType(
    chartOptions: ChartOptions,
    data: EVPData[]
): StrikeZone {
    if (chartOptions.strikeZone) {
        // respect any override
        return chartOptions.strikeZone
    }

    const personal = canBePersonalized(data)

    return personal ? 'personal' : 'average'
}
